import { styled } from 'styled-components'
import { m } from 'motion/react'

const MIN_ROW_HEIGHT = 80

export const Row = styled(m.div)`
  display: flex;
  align-items: flex-start;
  gap: 16px;
  min-height: ${MIN_ROW_HEIGHT}px;
`

export const Content = styled.div`
  display: flex;
  flex-direction: column;
  flex: 1;
  min-width: 0;
  min-height: ${MIN_ROW_HEIGHT}px;
`

export const TopSection = styled(m.div)<{ $alignTop?: boolean }>`
  display: flex;
  align-items: ${({ $alignTop }) => ($alignTop ? 'flex-start' : 'center')};
  ${({ $alignTop }) => !$alignTop && 'flex: 1'};
  gap: 8px;
`

export const TextContent = styled(m.div)`
  display: flex;
  flex-direction: column;
  gap: 4px;
  flex: 1;
  min-width: 0;
`

export const TitleButton = styled.button<{ $isClickable: boolean }>`
  display: inline-flex;
  align-items: center;
  gap: 4px;
  background: none;
  border: none;
  padding: 0;
  cursor: ${({ $isClickable }) => ($isClickable ? 'pointer' : 'default')};
  font-size: 16px;
  font-weight: 500;
  line-height: 140%;
  text-align: left;
  color: ${({ theme }) => theme.colors.black};
`

export const Chevron = styled.span<{ $isExpanded: boolean }>`
  display: flex;
  align-items: center;
  transition: transform 0.2s cubic-bezier(0.645, 0.045, 0.355, 1);
  transform: ${({ $isExpanded }) =>
    $isExpanded ? 'rotate(180deg)' : 'rotate(0deg)'};

  svg {
    width: 16px;
    height: 16px;
  }

  @media (prefers-reduced-motion: reduce) {
    transition: none;
  }
`

export const BottomRow = styled.div`
  display: flex;
  align-items: center;
  gap: 6px;
  font-size: 15px;
  line-height: 130%;
`

export const EditLink = styled.button`
  background: none;
  border: none;
  padding: 0;
  cursor: pointer;
  font-size: inherit;
  font-weight: 400;
  line-height: inherit;
  color: ${({ theme }) => theme.colors.black};
  text-decoration: underline;
  text-decoration-skip-ink: none;
  text-underline-position: from-font;
`

export const Separator = styled.span`
  color: ${({ theme }) => theme.colors.grayDark};
`

export const OriginalPrice = styled.span`
  text-decoration: line-through;
  color: ${({ theme }) => theme.colors.grayDark};
`

export const DiscountedPrice = styled.span`
  font-weight: 500;
  color: ${({ theme }) => theme.colors.black};
`

export const BreakdownWrapper = styled(m.div)`
  position: relative;
`

export const AlertContainer = styled.div`
  overflow: hidden;
  width: 100%;
  position: relative;
`

export const AlertSlot = styled(m.div)`
  padding-top: 7px;
`
